<template>
	<div class="layout">
		<el-container class="container">
			<el-aside class="aside" style="width: 210px !important;">
				<div class="head">
					<div @click="$router.push('/main/home')" style="cursor: pointer;">
						<img src="../../assets/logo.png" alt="logo">
						<span>Cosbravo</span>
					</div>
				</div>
				<div class="line" />
				<el-menu :default-active="checkIndex" background-color="#222832" text-color="#fff" default-active='2'>
					<el-submenu :index="i+''" v-for="(v,i) in menu" :key="i">
						<template #title>
							<span>{{v.title}}</span>
						</template>
						<el-menu-item-group>
							<el-menu-item @click="toContent(v1)" :key="i+'-'+i1" v-for="(v1,i1) in v.all_children" :index="v1.path"><i class="el-icon-data-line" />{{v1.title}}</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

				</el-menu>
			</el-aside>
			<el-container>
				<el-header>
					<div class="header">
						<div class="left">
							<!-- <i  class="el-icon-back" @click="back"></i> -->
							<span style="font-size: 20px">{{breadCrumb}}</span>
						</div>
						<div class="header_right">
							<div class="right">
								<el-popover placement="bottom" :width="320" trigger="click" popper-class="popper-user-box">
									<template #reference>
										<div class="author">
											<i class="icon el-icon-s-custom" />
											{{info.username}}
											<i class="el-icon-caret-bottom" />
										</div>
									</template>
									<div class="nickname">
										<p>登录名： {{info.username}}</p>
										<p>昵称： {{info.nick_name}}</p>
										<el-tag size="small" effect="dark" class="logout" @click.native='logout()'>退出</el-tag>
									</div>
								</el-popover>
							</div>
							<div>
								<span style="font-size: 20px" @click="goHome()">前台</span>
							</div>
						</div>
					</div>
				</el-header>
				<el-main>
					<div style="overflow: auto;flex: 1;" class="col">
						<router-view></router-view>
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>





<script>
	export default {
		name: 'Main',
		data() {
			return {
				isCollapse: true,
				menu: [],
				info: [],
				isRouterAlive: true,
				checkIndex: '',
				breadCrumb: '首页',
			}
		},
		watch: {
			// 监听路由
			$route(val) {
				// 调用获取路由数组方法
				this.getBread(val);
			}
		},
		methods: {
			goHome() {
				let home_url = this.webHost();
				window.open(home_url, '_blank');
			},
			getBread() {
				if (this.$route.path == '/main/home') {
					this.breadCrumb = '首页'
				} else {
					for (let i in this.menu) {
						for (let ii in this.menu[i].all_children) {
							if (this.$route.path === this.menu[i].all_children[ii].path) {
								this.breadCrumb = this.menu[i].title + '/' + this.menu[i].all_children[ii].title
							}
						}
					}
				}
			},
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			},
			getMenu() {
				this.httpPost({
					url: '/admin/menu/getMenu',
				}).then((res) => {
					this.menu = res.data;
					this.getBread();
				})
			},
			getAdminInfo() {
				this.httpPost({
					url: '/admin/home/home',
				}).then((res) => {
					this.info = res.data.admin_info;
					this.localSet('userId', this.info.id);
				})

			},
			toContent(obj) {
				this.$router.push(obj.path);

				// let routeData = this.$router.resolve({ path: obj.path });
				// window.open(routeData.href, '_blank');
			},
			logout() {
				if (this.info.id) {
					this.httpPost({
						url: '/admin/login/logout',
					}).then((res) => {
						this.localRemove('userId');
						this.$router.push('/login');
					})
				}
				// this.localRemove('token');

			},
		},
		created() {
			this.getMenu();
			this.getAdminInfo();
			this.getBread();
			this.checkIndex = this.$route.path;
			// if (window.console && window.console.log) {
			//       console.log('不好！被你发现了！');
			//       console.log('既然你发现了这个隐藏的秘密，就准备受死吧！');
			// }
		}
	}
</script>


<style>
	.layout {
		min-height: 100vh;
		background-color: #ffffff;
	}

	.container {
		height: 100vh;
	}

	.aside {
		background-color: #222832;
		overflow: hidden;
		overflow-y: auto;
		-ms-overflow-style: none;
		overflow: -moz-scrollbars-none;
	}

	.aside::-webkit-scrollbar {
		display: none;
	}

	.head {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 50px;
	}

	.head>div {
		display: flex;
		align-items: center;
	}

	.head img {
		width: 50px;
		height: 50px;
		margin-right: 10px;
	}

	.head span {
		font-size: 20px;
		color: #ffffff;
	}

	.line {
		border-top: 1px solid hsla(0, 0%, 100%, .05);
		border-bottom: 1px solid rgba(0, 0, 0, .2);
	}

	.content {
		display: flex;
		flex-direction: column;
		max-height: 100vh;
		overflow: hidden;
	}

	.main {
		height: calc(100vh - 100px);
		overflow: auto;
		padding: 10px;
	}
</style>
<style>
	body {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.el-menu {
		border-right: none !important;
	}

	.el-submenu {
		border-top: 1px solid hsla(0, 0%, 100%, .05);
		border-bottom: 1px solid rgba(0, 0, 0, .2);
	}

	.el-submenu:first-child {
		border-top: none;
	}

	.el-submenu [class^="el-icon-"] {
		vertical-align: -1px !important;
	}

	a {
		color: #409eff;
		text-decoration: none;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}

	.el-popper__arrow {
		display: none;
	}
</style>
<style scoped>
	.header {
		height: 50px;
		border-bottom: 1px solid #e9e9e9;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;
	}

	.header_right {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;
		cursor: pointer;
	}

	.el-icon-back {
		border: 1px solid #e9e9e9;
		padding: 4px;
		border-radius: 50px;
		margin-right: 10px;
	}

	.right>div>.icon {
		font-size: 18px;
		margin-right: 6px;
	}

	.right {
		margin-right: 30px;
	}

	.author {
		margin-left: 10px;
		cursor: pointer;
	}
</style>
<style>
	.popper-user-box {
		background: url('https://s.yezgea02.com/lingling-h5/static/account-banner-bg.png') 50% 50% no-repeat !important;
		background-size: cover !important;
		border-radius: 0 !important;
	}

	.popper-user-box .nickname {
		position: relative;
		color: #ffffff;
	}

	.popper-user-box .nickname .logout {
		position: absolute;
		right: 0;
		top: 0;
		cursor: pointer;
	}
</style>
